import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  API_ADD_OFFICENOTE,
  API_GET_OFFICENOTE,
} from "../api/officetime.service";

// Initial state for office notes
const initialState = {
  officeNotes: [],  
  loading: false,  
  selectedNote: null,  
};

// Async thunk to fetch office notes
export const getOfficeNotes = createAsyncThunk(
  "officeNote/getOfficeNotes",
  async (_, thunkAPI) => {
    try {
      const response = await API_GET_OFFICENOTE();  
      return response;  
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);  
    }
  }
);

// Async thunk to add a new office note
export const addOfficeNote = createAsyncThunk(
  "officeNote/addOfficeNote",
  async (configData, thunkAPI) => {
    try {
      const response = await API_ADD_OFFICENOTE(configData);  
      return response;  
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);  
    }
  }
);

const officeNoteSlice = createSlice({
  name: "officeNote",
  initialState,
  reducers: {
    selectNote: (state, action) => {
      state.selectedNote = action.payload;  
    },
    resetSelectedNote: (state) => {
      state.selectedNote = null;  
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOfficeNotes.fulfilled, (state, action) => {
      state.officeNotes = action.payload;  // Replace the existing officeNotes
      state.loading = false;
    });
    builder.addCase(getOfficeNotes.pending, (state) => {
      state.loading = true;  
    });
    builder.addCase(getOfficeNotes.rejected, (state) => {
      state.loading = false; 
    });
  },
});

export const { selectNote, resetSelectedNote } = officeNoteSlice.actions;

export default officeNoteSlice.reducer;
